export default __webpack_public_path__ + "static/media/management.e4adda08.svg";